import React from "react";
import Header from '../Component/Header';
import { useState,useEffect } from 'react';
import { Link,Navigate, useNavigate } from 'react-router-dom';
import apiService from '../Services/apiService';

const ManageUser=()=>{

return(<>
        <Header />
        <div className="min-hight75vh">
        ManageUser 
        </div>
</>)
}
export default ManageUser;